import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TQuizState = {
  data: [];
  perPage: number;
  currentPage: number;
  totalPage: number;
  searchTerm: string;
  loading: boolean;
  sortBy: string;
  sortColumn: string;
  rerender1: boolean;
  totalCount: number
};

const initialQuizState: TQuizState = {
  data: [],
  perPage: 10,
  currentPage: 1,
  totalPage: 1,
  searchTerm: "",
  loading: false,
  sortBy: "desc",
  sortColumn: "",
  rerender1: false,
  totalCount: 0
};

export const quizSlice = createSlice({
  name: "quiz",
  initialState: initialQuizState,
  reducers: {
    setQuiz: (state: TQuizState, { payload }: PayloadAction<[]>) => {
      state.data = payload;
    },
    setPerPage: (state: TQuizState, { payload }: PayloadAction<number>) => {
      state.perPage = payload;
    },
    setTotalCount: (state: TQuizState, { payload }: PayloadAction<number>) => {
      state.totalCount = payload;
    },
    setCurrentPage: (state: TQuizState, { payload }: PayloadAction<number>) => {
      state.currentPage = payload;
    },
    setTotalPage: (state: TQuizState, { payload }: PayloadAction<number>) => {},
    setSearchTerm: (state: TQuizState, { payload }: PayloadAction<string>) => {
      state.searchTerm = payload;
    },
    setSortBy: (state: TQuizState, { payload }: PayloadAction<string>) => {
      state.sortBy = payload;
    },
    setSortColumn: (state: TQuizState, { payload }: PayloadAction<string>) => {
      state.sortColumn = payload;
      state.sortBy = "desc";
    },
    setLoading: (state: TQuizState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setRerender: (state: TQuizState, { payload }: PayloadAction<boolean>) => {
      state.rerender1 = payload;
    },
  },
});

export const {
  setQuiz,
  setPerPage,
  setCurrentPage,
  setSortColumn,
  setSortBy,
  setTotalPage,
  setSearchTerm,
  setLoading,
  setRerender,
  setTotalCount
} = quizSlice.actions;
export default quizSlice.reducer;
